
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  // Get current location to determine which page we're on
  const location = useLocation();
  const isDashboardOrTracks = location.pathname === '/dashboard' || location.pathname === '/tracks';
  
  // Function to scroll to top on navigation
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  
  return (
    <footer className="bg-card/30 border-t border-border/20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="/lovable-uploads/a9aba44d-dd97-4587-89f4-832d11551e38.png" 
                alt="Dropify" 
                className="h-10" 
              />
            </div>
            <p className="text-sm text-muted-foreground">
              <strong>Drop Tracks. Get Fans.</strong>
            </p>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-sm font-medium">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Home
              </Link>
              <Link to="/contact" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contact
              </Link>
              <Link to="/dashboard" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Dashboard
              </Link>
              <Link to="/tracks" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Tracks
              </Link>
              {isDashboardOrTracks && (
                <Link to="/manage-subscription" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Manage Subscription
                </Link>
              )}
            </nav>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-sm font-medium">Legal</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/terms-of-service" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy-policy" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" onClick={scrollToTop} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Cookie Policy
              </Link>
            </nav>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-border/20 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Dropify. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
